import { getCookiesToState, setPersistCookie } from '@/common/utils'

const persistCookies =
  (slices, ctx = {}) =>
  (store) =>
  (next) =>
  (action) => {
    const result = next(action)
    const state = store.getState()

    slices.forEach((slice) => {
      setPersistCookie(getCookiesToState(slice), state[slice], ctx)
    })

    return result
  }

export default persistCookies
